import { NgModule } from '@angular/core';
import { AssetsModelModule } from 'assets-model';
import { UimCommonModule } from '@scisys-uim/uim-common';


@NgModule({
  declarations: [
  ],
  imports: [
    UimCommonModule,
    AssetsModelModule
  ],
  exports: [
  ]
})
export class AssetsServiceModule { }
